import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../common';
import { selectionsApiSlice } from '../selection';
import { log } from '@src/utils';

export const generationTaskApiSlice = createApi({
  reducerPath: 'generationTask/api',
  baseQuery: axiosBaseQuery({
    baseUrl: 'generation-task',
  }),
  endpoints: builder => ({
    generationTask: builder.query<unknown, number>({
      query: id => ({
        url: `?id=${id}`,
        method: 'POST',
      }),
      onQueryStarted: (_arg, api) => {
        api.queryFulfilled
          .then(() => api.dispatch(selectionsApiSlice.util.invalidateTags(['SelectionsRefetch'])))
          .catch(log);
      },
    }),
  }),
});
